import GeneralFilter from '../../../../Model/GeneralFilter'

export default class RoleFilter extends GeneralFilter {
  constructor () {
    super()
    this.setInitialValue()
  }

  setInitialValue () {
    this.setFilterInitialValue()
  }
}
